import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Facebook } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
    { name: 'Directions', path: '/directions' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        {/* Top bar */}
        <div className="border-b border-teal-100 py-2">
          <div className="flex justify-between items-center text-sm">
            <div className="flex items-center gap-4">
              <a href="tel:+447523414727" className="flex items-center gap-2 text-teal-700 hover:text-teal-600 transition-colors">
                <Phone size={14} />
                <span className="hidden sm:inline">+44 7523 414727</span>
              </a>
              <a 
                href="https://www.facebook.com/share/18HLp4YjZz/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-teal-700 hover:text-teal-600 transition-colors"
              >
                <Facebook size={14} />
                <span className="hidden sm:inline">Follow Us</span>
              </a>
            </div>
            <div className="text-teal-600 text-xs sm:text-sm">
              Open Tue-Sat 9AM-4PM
            </div>
          </div>
        </div>

        {/* Main navigation */}
        <div className="py-4 flex justify-between items-center">
          <Link to="/" className="flex flex-col">
            <h1 className="text-2xl sm:text-3xl font-serif font-bold text-teal-800">
              J.B.F. Antiques
            </h1>
            <span className="text-xs sm:text-sm text-teal-600 tracking-wider">& GALLERY</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium tracking-wide transition-colors relative ${
                  isActive(link.path)
                    ? 'text-teal-700'
                    : 'text-gray-700 hover:text-teal-700'
                }`}
              >
                {link.name}
                {isActive(link.path) && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-teal-700"></span>
                )}
              </Link>
            ))}
          </nav>

          {/* Mobile menu button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </Button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-teal-100 bg-white">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`text-base font-medium py-2 px-4 rounded transition-colors ${
                  isActive(link.path)
                    ? 'bg-teal-100 text-teal-800'
                    : 'text-gray-700 hover:bg-teal-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
